<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="card">
      <div class="card-body">
        <b-row class="align-content-between">
          <b-col xl="2" lg="2" md="6" sm="12" class="pt-1">
            <rating-filter @ratingOption="handleRatingOption"></rating-filter>
          </b-col>
          <b-col xl="3" lg="3" md="6" sm="12" class="pt-1">
            <market-place-component @input="handleMarketplace"/>
          </b-col>
          <b-col xl="3" lg="3" md="6" sm="12" class="pt-1">
            <date-picker v-model="dateRange"
                         range
                         append-to-body
                         :lang="$i18n.locale"
                         confirm
                         @change="handleDate"
                         valueType="timestamp"
                         :placeholder="$t('pages.feedbacks.date_range')"
                         format="DD/MM/YYYY"></date-picker>
          </b-col>
          <b-col xl="4" lg="4" md="4" sm="4" class="text-end pt-1">
            <b-btn disabled variant="success" v-b-modal:feedback-removal-tool>
              <i class="mdi mdi-tooltip-minus"></i>
              {{ $t('pages.feedbacks.feedback_removal_tool') }}
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="col-sm-12">
          <div class="row">
            <div class="col-sm-6 col-12">
              <PerPageSelector v-model="query.perPage"
                               :available-per-page-options="availablePerPageOptions"
              ></PerPageSelector>
            </div>
            <div class="col-sm-3 offset-lg-3 offset-md-3 offset-sm-3 col-12">
              <DataTableSearch v-model="query.filter"
                               :place-holder="$t('pages.feedbacks.search')">
              </DataTableSearch>
            </div>
          </div>
        </div>
        <div>
          <b-table
              ref="feedbackTable"
              striped
              hover
              :empty-text="$t('components.bootstrap_table.empty_text')"
              :empty-filtered-text="$t('components.bootstrap_table.empty_filtered_text')"
              show-empty
              :fields="fields"
              :items="getFeedbacks"
              :stacked="$store.state.app.isMobile"
              :filter="query.filter"
              :per-page="query.perPage"
              :sort-by="query.sortBy"
              :sort-desc="query.sortDesc"
              :current-page="query.page"
          >
            <template #cell(order.amazon_order_id)="data">
              <h5>
                <span
                    class="badge badge-soft-secondary">{{
                    data.item.order ? data.item.order.amazon_order_id : '-'
                  }}</span>
              </h5>
            </template>


            <template #cell(date)="data">
              <span> {{ data.item.date | date}}</span>
            </template>


            <template #cell(rating)="data">
              <Star :star="data.item.rating"></Star>
            </template>

            <template #cell(action)="data">
              <b-btn @click="removeRequest(data.item.id)"
                     variant="danger"
                     size="sm"
                     class="btn-rounded"
                     :disabled="data.item.removal && data.item.removal.hasOwnProperty('created_at')">
                <i class="mdi mdi-delete-restore"></i>
                {{ $t('pages.feedbacks.remove_request') }}
              </b-btn>
            </template>

          </b-table>
          <div class="row">
            <div class="col-sm">
              <Pagination v-model="query.page" :meta="feedback.meta"></Pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <feedback-chart :data="dailyCounts"/>
    <feedback-removal-tool-modal/>
  </div>
</template>


<script>
import queryBuilder from "../../mixins/queryBuilder";
import PerPageSelector from "../../components/PerPageSelector";
import DataTableSearch from "../../components/DataTableSearch";
import FeedbackService from "../../Services/Api/FeedbackService";
import Star from "../Reviews/components/Star";
import MarketPlaceComponent from "../../components/widgets/MarketPlaceComponent";
import RatingFilter from "../Reviews/components/RatingFilter";
import FeedbackRemovalToolModal from "./Components/FeedbackRemovalToolModal";
import Swal from "sweetalert2";
import FeedbackChart from "./Components/FeedbackChart";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    FeedbackChart,
    FeedbackRemovalToolModal,
    RatingFilter,
    MarketPlaceComponent,
    DataTableSearch,
    PerPageSelector,
    Star,
    DatePicker
  },
  page() {
    return {
      title: this.$t('pages.feedbacks.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  name: "Feedback",
  mixins: [queryBuilder],
  data() {
    return {
      title: this.$t('pages.feedbacks.title'),
      items: [
        {
          text: this.$t('pages.feedbacks.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.feedbacks.items.second'),
          active: true,
        },
      ],
      fields: [
        {
          key: 'order.amazon_order_id',
          sortable: false,
          label: this.$t('pages.feedbacks.fields.order_id'),
          tdClass: "order-cell"
        },
        {key: 'rating', sortable: false, label: this.$t('pages.feedbacks.fields.rating'), tdClass: "star-cell"},
        {key: 'comment', sortable: false, label: this.$t('pages.feedbacks.fields.comment')},
        {key: 'date', sortable: true, label: this.$t('pages.feedbacks.fields.date'), tdClass: "date-cell"},
        {key: 'action', sortable: false, label: this.$t('pages.feedbacks.fields.removal'), tdClass: "removal-cell"},
      ],
      feedback: {},
      dailyCounts: null,
      dateRange: null
    };
  },
  methods: {
    async getFeedbacks(params = this.query) {
      this.query = {...this.query, ...params}
      const query = this.buildQuery()
      const {data: feedback} = await FeedbackService.all({query})
      this.feedback = feedback
      return feedback.data
    },
    handleDate(e) {
      this.query.date = e[0] ? e.join(',') : null
      this.$refs.feedbackTable.refresh()
    },
    async getFeedbackDaily() {
      const {data: daily} = await FeedbackService.getFeedbackDaily()
      this.dailyCounts = daily.data
    },
    handleRatingOption(e) {
      this.query.ratingOption = e
      this.$refs.feedbackTable.refresh()
    },
    handleMarketplace(e) {
      this.query.marketplace = e.map(item => item.marketplace_id).join(',')
      this.$refs.feedbackTable.refresh()
    },
    removeRequest(feedbackId) {
      Swal.fire({
        title: this.$t('pages.feedbacks.removal_request_modal.title'),
        imageUrl: require('@/assets/images/amazon/amazon_feedback_removal.png'),
        width: 620,
        imageWidth: 420,
        imageHeight: 420,
        imageAlt: 'official-feedback',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t('pages.feedbacks.removal_request_modal.confirm')
      }).then(result => {
        if (result.value) {
          FeedbackService.removal({
            payload: {
              'reason': null,
              'feedback_id': feedbackId
            }
          }).then(() => {
            Swal.fire({
                  title: this.$t('pages.feedbacks.removal_request_modal.success'),
                  icon: "success",
                  confirmButtonColor: "#34c38f",
                  confirmButtonText: this.$t('pages.feedbacks.removal_request_modal.confirm')
                }
            ).then(() => {
              this.$refs.feedbackTable.refresh()
            })
          })
        }
      });
    }
  },
  created() {
    this.query.sortBy = 'date'
    this.getFeedbackDaily()
  }
};
</script>
<style scoped>
/deep/ .star-cell {
  min-width: 10em !important;
}

/deep/ .order-cell {
  min-width: 13em !important;
}

/deep/ .date-cell {
  min-width: 8em !important;
}

/deep/ .removal-cell {
  min-width: 14em !important;
}
</style>